import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService {
  constructor(private http: HttpClient) {}

  get<T>(url: string, params?: Record<string, string>): Observable<T> {
    const httpParams = this.buildParams(params);
    return this.http.get<T>(url, { params: httpParams });
  }

  post<T>(url: string, body: any, params?: Record<string, string>): Observable<T> {
    const httpParams = this.buildParams(params);
    return this.http.post<T>(url, body, { params: httpParams });
  }

  put<T>(url: string, body: any, params?: Record<string, string>): Observable<T> {
    const httpParams = this.buildParams(params);
    return this.http.put<T>(url, body, { params: httpParams });
  }

  delete<T>(url: string, params?: Record<string, string>): Observable<T> {
    const httpParams = this.buildParams(params);
    return this.http.delete<T>(url, { params: httpParams });
  }

  private buildParams(params?: Record<string, string>): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return httpParams;
  }
}